<template>
  <div class="login_container">
    <img v-if="isDev" class='login_bg' src='@/assets/images/login/login_bg.png' />
    <img v-if="isDev" class='login_top_title'  src='@/assets/images/login/login_title.png' />
    <img v-else class='login_top_title'  src='@/assets/images/login/login_title_test.png' />
    <div class='left_container'>
      <div v-if="isDev" class='left-top'>北京大兴国际机场货运区工程（国际货代区等）一标段</div>
      <div v-else class='left-top left-center'>
        <span>
          机场货运区工程 <br/>（国际货代区等）一标段
        </span>
      </div>
      
      <div  class='left-bottom'>
        <img class='left_bg' src='@/assets/images/login/login_liner.png' />
        <div class='left_txt'>引领世界机场建设 · 打造全球空港标杆</div>
      </div>
    </div>
    <div class='right_container'>
      <div class="right">
        <el-form
          ref="loginForm"
          v-if="loginProgress ==1"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          label-position="left">
          <div class="title">账号登录</div>
          <el-form-item prop="LoginName" class='loginName'>
            <el-input
              ref="name"
              v-model="loginForm.LoginName"
              autofocus="autofocus"
              name="LoginName"
              type="text"
              autocomplete="off"
              placeholder="请输入账号"
              class='userImg'
              @keyup.enter.native="handleLogin" />
          </el-form-item>
          <el-form-item prop="LoginPassword" class='loginName'>
            <el-input
              v-model="loginForm.LoginPassword"
              type="password"
              name="LoginPassword"
              autocomplete="off"
              placeholder="请输入密码"
              class='userImg pswImg'
              @keyup.enter.native="handleLogin" />
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="loading"
              class="submit-btn"
              @click.native.prevent="handleLogin">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  components: { },
  data () {
    const validateLoginName = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      // let psd = /^[A-Za-z0-9]{1,20}$/
      if (value === '') {
        callback(new Error('请输入密码'))
      }
      // else if (!psd.test(value)) {
      //   callback(new Error('请输入至少包含 数字和英文，长度6-20的密码'))
      // } 
      else {
        callback()
      }
    }
    // const validateCode = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入验证码'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loginProgress: '1', // 1 登录  2 重置密码验证  3 重置密码
      loginForm: {
        LoginName: '',
        LoginPassword: '',
        // VerifyCode: ''
      },
      vertifyForm: {
        ResetName: '',
        ResetCode: ''
      },
      loginRules: {
        LoginName: [
          { required: true, trigger: 'change', validator: validateLoginName }
        ],
        LoginPassword: [{ required: true, trigger: 'change', validator: validatePass }],
        // VerifyCode: [
        //   { required: true, trigger: 'change', validator: validateCode }
        // ]
      },
      loading: false,
      vertifyloading: false, // 验证
      resetloading: false, // 重置
      redirect: undefined,
      remember: false,
      identifyCodes: [1, 2, 3, 4],
      identifyCode: '3333',
      codeMsg: '获取验证码',
      countdown: 60,
      timer: null,
      codeDisabled: true,
      loginImg: '',
      loginToken: '',
      PublicKey:"MK4ZJF10PRO19*#8",
      isDev: false,  // false为非生产环境，true为生产环境
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        console.log(route)
      },
      immediate: true
    }
  },
  mounted () {
    if(location.href.indexOf('cockpit-dcpmp') > -1){
     this.isDev = true;
    }else{
     this.isDev = false;
    }
  },
  methods: {
   handleLogin(){
     this.$refs.loginForm.validate(valid => {
      if (!valid) return
      let data = {
        UserName: this.loginForm.LoginName,
        Password: this.computepwdstr(
          this.loginForm.LoginPassword+this.PublicKey,
          this.$CryptoJS
        )
      };
      let postdata = this.$qs.stringify(data);
       this.$axios({
        method: "post",
        url: `${window.pubilc_config.webserverurl}/api/User/Home/Login`,
        data: postdata
      }).then(res =>{
        if (res.data.Ret == -1) {
            this.$message.error(res.data.Msg);   
        } else if (res.data.Ret == 1 && res.data.Data) {
            window.localStorage.removeItem("Token");
            let _tval = res.data.Data.token;
            window.localStorage.setItem("Token", _tval);
            
            this.loading = true
            // this.$message.success('登录成功！')
            this.$message({
              duration: 1000,
              message: '登录成功！',
              type: 'success'
            });
            this.$router.replace('/plist')
          }
      }).catch(x =>{
          this.$message.warning(x)
      })
     })
   },
   
    // 对称加密算法
    // json.input   输入的明文
    // json.key     加密密钥
    // return value 正常时返回：加密后的密码，异常时返回-1

    SymmetricEncryption(json, CryptoJS) {

        // parameter tests
        if (!json || !json.input || !json.key) {
            console.warn("json, json.input and json.key are not allow null!");
            return -1;
        }

        // 由于 key 小于16位会有问题，需要额外处理 key
        if (json.key.length == 0) {
            console.warn("json.length should not be zero!");
            return -1;
        }
        while (json.key.length < 16) {
            json.key = json.key + json.key;
        }
        // //由于 key 小于16位会有问题，需要额外处理 key

        //var CryptoJS = Vue.prototype.$CryptoJS;

        var KEY = json.key; //32位
        var IV = "*BIM19FF4KMY0R8*"; //16位
        var key = CryptoJS.enc.Utf8.parse(KEY);
        var iv = CryptoJS.enc.Utf8.parse(IV);

        var encrypted = "";

        var srcs = CryptoJS.enc.Utf8.parse(json.input);
        encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.ciphertext.toString(); //5c1b2248cb4ba581472afab0702518cc
    },
    // //对称加密算法

    computepwdstr(pwdorigin, _this_CryptoJS) {
        var that = this;
        var afterpwd = that.SymmetricEncryption({
            input: pwdorigin,
            key: this.PublicKey
        }, _this_CryptoJS);
        return afterpwd;
    },
  }
}
</script>

<style lang='less' scoped>
@media screen and (max-width:1366px) and (min-width:300px){
    .login_bg{
      width: 100%;
      position: absolute;
      content: '1366';
      left: 0;
      bottom: 0;
    }
}
@media screen and (max-width:1440px) and (min-width:1367px){
    .login_bg{
      width: 100%;
      position: absolute;
      content: '1440';
      left: 0;
      bottom: 0;
    }
}
@media screen and (max-width:1920px) and (min-width:1441px){
    .login_bg{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
}
  .login_container{
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(11, 26, 53);
    min-width: 1300px;
    display: flex;
    align-items: center;
    -moz-user-select: auto;
    -o-user-select:auto;
    -khtml-user-select:auto;
    -webkit-user-select:auto;
    -ms-user-select:auto;
    user-select:auto;
    .login_bg{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .login_top_title{
      // height: 60px;
      position: absolute;
      left: 40px;
      top: 40px;
    }
    .left_container{
      position: absolute;
      left: 13%;
      transform:translateX(-20%);
      display: flex;
      flex-direction: column;
      align-items: center;
      .left-top{
        width: 650px;
        font-size: 50px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 72px;
        margin-bottom: 54px;
      }
      .left-center{
        text-align: center;
      }
      .left-bottom{
        font-size: 30px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        .left_bg{
          width: 1000px;
          height: 65px;
          position: relative;
        }
        .left_txt{
          position: absolute;
          left: 22%;
          bottom: 24px;
        }
      }
    }
    .right_container{
      position: absolute;
      left: 72%;
      transform:translateX(-50%);
      width: 740px;
      height: 500px;
      background: rgba(11, 26, 53, 0.55);
      display: flex;
      .right {
        position: relative;
        width: 100%;
        background: rgba(11, 26, 53, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .login-form {
          width: 480px;

          .title {
            font-size: 32px;
            color: rgba(255,255,255,0.72);
            margin: 0 auto 50px;
            text-align: center;
          }
          .loginName{
            margin-bottom: 50px;
          }
          .userImg /deep/ .el-input__inner{
            background: url("../assets/images/login/user.png") no-repeat 0 0;
            background-size: 24px 24px;
            background-position: 30px 20px;
            text-indent: 50px;
            height: 64px;
            color: rgba(255,255,255,0.85);
            font-size:24px;
            padding-left: 41px;
          }
          .pswImg /deep/ .el-input__inner{
            background: url("../assets/images/login/password.png")no-repeat 0 0;
            background-size: 24px 24px;             
            background-position: 30px 20px;
          }
          .submit-btn {
            width: 480px;
            line-height: 2;
            font-size: 24px;
            color: #fff;
            border-radius: 3px;
            background-color: #2899FF;
            display: block;
          }
          .codeBtn{
            width: 124px;
            height: 40px;
            line-height: 1;
            font-size: 14px;
            color: white;
            border-radius: 3px;
            background-color: #ff7d00;
            display: block;
            margin-left: 20px;
          }
          .getPsd{
            color: #333;
            font-size: 14px;
            cursor:pointer;
            float:right;
            &:hover{
              color:#ff7d00;
            }
          }
          .el-button {
            border: 0 none;
          }
          .action-control {
            color: #999;
            /deep/ .el-checkbox {
              .el-checkbox__label {
                color: #999;
              }
              .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #ff7d00;
                border-color: #ff7d00;
              }
            }

            .forget {
              cursor: pointer;
              float: right;
            }
          }
        }

        .register {
          width: 70%;
          padding-top: 30px;
          color: #333;
          border-top: 1px solid #e6e6e6;
          text-align: center;
          margin-top: 28px;
          .register-btn {
            color: #ff7d00;
            cursor: pointer;
          }
        }

        .copyright {
          width: 92%;
          position: absolute;
          bottom: 5%;
          color: #d0d0d0;
          font-size: 12px;
          text-align: center;
          line-height: 1.5;
        }
      }
    }

    .logo {
      position: absolute;
      left: 60px;
      top: 0px;
      width: 200px;
      height: 200px;
      z-index: 200;
    }
    .loginImg{
      width: 124px;
      margin-left: 20px;
    }
  }

</style>
